import React from 'react';
import { Button } from 'carbon-components-react';
import { ArrowRight16 } from '@carbon/icons-react';

interface WizardFooterProps {
  onBack?: () => void;
  primaryLabel: string;
  onPrimaryClick: () => void;
  primaryDisabled?: boolean;
  primaryLoading?: boolean;
  showBack?: boolean;
  showPrimary?: boolean;
}

const WizardFooter: React.FC<WizardFooterProps> = ({
  onBack,
  primaryLabel,
  onPrimaryClick,
  primaryDisabled = false,
  primaryLoading = false,
  showBack = true,
  showPrimary = true
}) => {
  return (
    <div className="wizard-footer">
      <div>
        {showBack && onBack && (
          <Button kind="ghost" onClick={onBack}>
            Back
          </Button>
        )}
      </div>
      {showPrimary && (
        <Button
          kind="primary"
          onClick={onPrimaryClick}
          disabled={primaryDisabled || primaryLoading}
          renderIcon={ArrowRight16}
        >
          {primaryLabel}
        </Button>
      )}
    </div>
  );
};

export default WizardFooter;
